export const DASHBOARDS = "/";
export const SITE_STRUCTURE_BASE = "/sitestructure";
export const SITE_STRUCTURE = "/sitestructure/:path+";
export const PREVIEW_PAGE = "/preview/:node";
export const PERMISSIONS = "/permissions";
export const LINK_RULES = "/linkrules";
